const { loadFormErrors } = require("./formErrors");
const createErrorNotification = require("base/components/errorNotification");
const recaptcha = require("google/recaptcha");
const { setCSRFToken, setBirthdateInput } = require("./utils");

/**
* Displays the corporate user registration confirmation message and hides the registration form.
* Removes the 'd-none' class from the confirmation element to make it visible,
* and adds the 'd-none' class to the registration form to hide it.
*
* @returns {void}
*/
function displayCorporateUserConfirmation() {
    $(".js-register-form-confirmation").removeClass("d-none");
    $(".js-registration-corporate").addClass("d-none");
}

/**
* Handles the registration process for a user, including form validation, reCAPTCHA token setting, CSRF token setting, and AJAX submission.
* @param {boolean} isBirthDateRequired - Indicates whether the birthdate input is required for registration.
*/
function register(isBirthDateRequired) {
    const formSelector = "form.registration";
    const $formRegistration = $(formSelector);
    let invalid_class = "is-invalid";
    $formRegistration.find(".js-grouped-fields select").on("change", function() {
        let $formGroup = $(this).parents(".form-group");
        $formGroup.removeClass(invalid_class).find(".invalid-feedback").empty();
    });

    $formRegistration.submit(function (e) {
        var $form = $(this);
        e.preventDefault();

        var $loginForm = $("#login-form");

        recaptcha.setToken({ formSelector: formSelector })
            .then(() => setCSRFToken({ $form: $form  }))
            .then(function () {
                if (isBirthDateRequired) {
                    setBirthdateInput(".register-birthdate");
                }
                var url = $form.attr("action");
                $form.spinner().start();
                $formRegistration.trigger("login:register", e);
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    data: $form.serialize(),
                    success: function (data) {
                        let $groupedValue = $form.find(".js-grouped-value");
                        $form.spinner().stop();
                        if (!data.success) {
                            $formRegistration.trigger("login:register:error", data);
                            $groupedValue.removeClass(invalid_class);
                            loadFormErrors($form, data);
                        } else {
                            if ($(".js-registration-corporate").length) {
                                displayCorporateUserConfirmation();
                                $loginForm.find("input[type='hidden'][name='csrf_token']").remove();
                                setCSRFToken({ $form: $loginForm  });
                            } else {
                                $formRegistration.trigger("login:register:success", data);
                                location.href = data.redirectUrl;
                            }
                        }
                        if ($groupedValue.length) {
                            $groupedValue.parent().toggleClass(invalid_class, $groupedValue.hasClass(invalid_class));
                        }
                    },
                    error: function (err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            createErrorNotification($(".error-messaging"), err.responseJSON.errorMessage || err.responseJSON.message);
                        }

                        $form.spinner().stop();
                    }
                });
            });
        return false;
    });

    /**
    * Handles the click event on the registration submit button REFRESH SONAR X2.
    * If the registration form exists, it removes the "animated" class from it.
    */
    $(".registration-submit-btn").on("click", function () {
        if ($formRegistration.length) {
            $formRegistration.removeClass("animated");
        }
    });

    /**
    * Adds an event listener to input and select elements within the registration form.
    * When an invalid event is triggered, it focuses on the invalid element and adds an "animated" class to the form if it doesn't already have it.
    */
    $(".registration input, .registration select").on("invalid", function () {
        if (!$formRegistration.hasClass("animated")) {
            $(this).focus();
            $formRegistration.addClass("animated");
        }
    });
}

/**
* Attaches a submit event handler to the guest checkout form, handles form submission via AJAX, and processes the response.
*/
function submitGuest() {
    const $formCheckoutGuest = $("form.checkoutGuest");
    $formCheckoutGuest.on("submit", function (e) {
        e.preventDefault();
        var form = $(this);
        var url = form.attr("action");

        form.spinner().start();
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: form.serialize(),
            success: function (data) {
                form.spinner().stop();
                if (!data.success) {
                    loadFormErrors(form, data);
                } else {
                    if (data.redirectUrl) {
                        location.href = data.redirectUrl;
                    }
                }
            },
            error: function (err) {
                form.spinner().stop();
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.message);
                }
            }
        });
        return false;
    });
}

module.exports = {
    register,
    submitGuest
};
